export const ACCEPTED_IMAGE_FORMATS = ".jpg,.jpeg,.png,.webp,.svg";
export const ACCEPTED_DOCUMENT_FORMATS = ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt";
export const ACCEPTED_BOTH_FORMATS = `${ACCEPTED_IMAGE_FORMATS},${ACCEPTED_DOCUMENT_FORMATS}`;

export type FileUploadType = 'image' | 'document' | 'both';

export const getAcceptedFormats = (type?: FileUploadType, customAccept?: string) => {
  if (customAccept) return customAccept;
  
  switch (type) {
    case 'image':
      return ACCEPTED_IMAGE_FORMATS;
    case 'document':
      return ACCEPTED_DOCUMENT_FORMATS;
    case 'both':
      return ACCEPTED_BOTH_FORMATS;
    default:
      // If nothing is specified, fallback to BOTH for backwards compatibility
      return ACCEPTED_BOTH_FORMATS;
  }
};
